const isLoggedIn = () => !!localStorage.getItem("authUser");

export default isLoggedIn;
